import axios, { AxiosPromise } from 'axios';
import ApiService from '@/api/http/ApiService';
import { Page } from '@/interfaces/api/Page';
import { Pagination } from '@/interfaces/api/Pagination';
import { ComoGift, ComoManagedGift } from '@/interfaces/models/ComoManagedGift';

export default class ComoManagedGiftApiService extends ApiService<any> {
  constructor() {
    super('como');
  }

  public paginate(
    page: Page,
    filter?: { giftType?: string; status?: string; templateKey?: string },
  ): AxiosPromise<Pagination<ComoManagedGift>> {
    return axios.get(`${this.getBaseUrl()}/managed-gifts/paginate`, {
      params: { page: page.page, limit: page.limit, ...filter },
    });
  }

  public gifts(venueId: string): AxiosPromise<ComoGift[]> {
    return axios.get(`${this.getBaseUrl()}/gifts`, { params: { venue: venueId } });
  }

  public create(gift: Partial<ComoManagedGift>): AxiosPromise<ComoManagedGift> {
    return axios.post(`${this.getBaseUrl()}/managed-gifts`, gift);
  }

  public updateManagedGift(id: string, gift: Partial<ComoManagedGift>): AxiosPromise<ComoManagedGift> {
    return axios.patch(`${this.getBaseUrl()}/managed-gifts/${id}`, gift);
  }

  public uploadImage(id: string, file: FormData): AxiosPromise<ComoManagedGift> {
    return axios.patch(`${this.getBaseUrl()}/managed-gifts/${id}/image`, file);
  }

  public delete(id: string): AxiosPromise<void> {
    return axios.delete(`${this.getBaseUrl()}/managed-gifts/${id}`);
  }
}
